import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Element as ReactScrollElement, scroller } from 'react-scroll';

import ABTest from '../../abtest/components/abtest';
import { withError } from '../../shared/components/error-boundary';
import SMBSlider from '../../shared/components/smb-slider';
import BadgeContainer from '../../main/components/badge-container';
import BadgeBanner from '../../main/components/badge-banner';
import HeroBanner from '../../hero-banner/hero-banner';
import ProductHeader from '../../product/components/product-header';
import TopBanner from '../../top-banner/top-banner';
import ComingSoon from '../../main/components/coming-soon';
import { Helpers } from '../../core/src/helpers';
import { fetchProducts, prefetchProducts } from '../../product/product-actions';
import '../../main/css/main.less';

const { memoize } = Helpers;

const filtersObj = memoize(
	(filters) => Helpers.parseFilters(filters)
);

const mapPglist = memoize(
	(productGroups, location) => {
		const search = Helpers.getSearch(location.search);

		return productGroups.map(pg => ({
			name: pg.name,
			key: pg.key,
			fontIcon: pg.fontIcon,
			tabLink: pg.tabLink,
			search
		}))
	}
);

const reducePgKeys = memoize(
	(productGroups) => {
		return productGroups.reduce((obj, pg) => {
			obj[pg.key] = pg.key;
			return obj;
		}, {})
	}
);

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

class SalePageTemplate extends React.Component {
	//static whyDidYouRender = true;

	constructor(props) {
		super(props);
		this.state = { hideIntelBadge: false };
		this.scrollTop = this.scrollTop.bind(this);
	}

	scrollTop(options = {}, target = 'SLPBody') {
		if (window.innerWidth <= 640) {
			scroller.scrollTo(target, {
				duration: 1000,
				smooth: true,
				offset: -100, //offset for header tab height
				...options
			});
		}
	}

	getTemplateDerivedProps = () => {
		const { components, filtersObj, defaultPg, slugInfo, match,
			productList, activePG, pg,
			disableIntelIcon, disableMSIcon } = this.props;
		const { templateKey } = slugInfo || {};
		const { pageOptimization, leftMenu, productTab } = components || {};
		const { productGroups = [] } = productTab || {};
		const { enableAppPDP } = productTab || {};

		// dont show badge containers for gift-guides
		const { disableAutoHide, autoHideType } = Helpers.getAutoHideComponent(slugInfo);
		const { prefetchTabs } = pageOptimization || {};
		const { dir, slug, filters } = (match && match.params) || {};
		const scrollTop = this.scrollTop;
		const isV2 = templateKey === 'sale-v4';
		let showBadgeContainer = (templateKey === 'sale-v3' || isV2) && (!disableIntelIcon || !disableMSIcon);

		return {
			productGroups, scrollTop, showBadgeContainer,
			productGroup: activePG, prefetchTabs, enableAppPDP,
			slug, filters, disableAutoHide,
			autoHideType, leftMenu, pg, isV2
		};
	}

	render() {
		const {
			activePG,
			components,
			match,
			templateKey,
			disableIntelIcon,
			disableMSIcon
		} = this.props;
		let templateProps = this.getTemplateDerivedProps();

		let { pg, showBadgeContainer, isV2 } = templateProps || {};
		let { heroBanner = {} } = components;
		let { metaData = {}, productsList } = activePG || {}
		const { basename, slug } = match.params;
		const filterDisplayType = metaData.filterDisplayType || 'disabled';
		const isToggleFilter = (filterDisplayType === 'toggle' || filterDisplayType === 'toggle-expanded');
		let badgeComponent = (<BadgeBanner
			className={'badge-header'}
			showFor={['desktop']}
		>
			{disableIntelIcon ? null : <BadgeContainer key='intel' className='intel-badge' customMessage={['Intel® Core™ Processors.']} />}
			{disableMSIcon ? null : <BadgeContainer
				className='ms-badge'
				key='ms'
				src={!isToggleFilter && !isV2 ? 'https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/windows-101590180628281715.png' : 'https://store.hp.com/app/static/img/windows-white.png'}
				customMessage={["Innovation has never looked so good"]}
			/>}
		</BadgeBanner>);
		return (<React.Fragment>
			{this.props.sliderBox && this.props.sliderBox.enableSliderBox && <SMBSlider />}
			<TopBanner
				html={metaData.heroBanner || heroBanner.bannerHtml}
				countDownEnabled={heroBanner.countDown}
				endtime={heroBanner.endTime}
				countDownFormat={heroBanner.countDownFormat}
				countDownMessage={heroBanner.countDownMessage}
				css={this.props.customCSS}
				className={(isToggleFilter || isV2) && showBadgeContainer ? 'with-badge-container' : ''}
				isV2={isV2}
			>
				{(isToggleFilter || isV2) && showBadgeContainer && badgeComponent}
			</TopBanner>
			{this.props.isComingSoon ?
				<ComingSoon comingSoonLinks={this.props.comingSoonLinks} intelBadge={this.props.comingSoonIntel} /> :
				<Fragment>
					<ReactScrollElement name='SLPHeader'>
						<ProductHeader
							currentPG={pg}
							pgList={this.props.pgList || []}
							slug={slug}
							basename={basename}
							scrollTop={!process.env.ISNODE ? this.scrollTop : null}
							isV2={isV2}
						/>
					</ReactScrollElement>
					{
						metaData.productGroupHero && templateKey !== 'gift-guide' ?
							<HeroBanner
								className="pg-custom-banner"
								customHtml={metaData.productGroupHero}
								maxHeight={metaData.maxPGBannerHeight}
								productsList={productsList}
							/> : null
					}
					{showBadgeContainer && !isToggleFilter && !isV2 && badgeComponent}
					<div className={`main-content${isV2 ? ' v2' : ''}`}>
						<ReactScrollElement name='SLPBody'>
							{
								this.props.children({
									...this.props,
									...templateProps
								})
							}
						</ReactScrollElement>
					</div>
				</Fragment>
			}
			{showBadgeContainer && <BadgeBanner
				className={'badge-footer'}
				showFor={['mobile', 'tablet']}
			>
				{disableIntelIcon ? null : <BadgeContainer key='intel' className='intel-badge' customMessage={['Intel® Core™ Processors.']} />}
				{disableMSIcon ? null : <BadgeContainer
					className='ms-badge'
					key='ms'
					src='https://www.hp.com/us-en/shop/app/assets/images/uploads/prod/windows-101590180628281715.png'
					customMessage={["Innovation has never looked so good"]}
				/>}
			</BadgeBanner>}
		</React.Fragment>);
	}
}

SalePageTemplate.defaultProps = {
	isComingSoon: false,
};

const getActivePG = Helpers.memoize((pgKey, productList, productGroups) => {
	let pgInfo = Array.isArray(productGroups)
		? productGroups.find(pg => pg && pg.key === pgKey)
		: {};
	return {
		...productList[pgKey] || {},
		...pgInfo || {}
	};
}, (pgKey, productList, productGroups) => `${pgKey}-${pgKey in productList ? productList[pgKey].prefetch : 'na'}-${Array.isArray(productGroups)}`);

const mapStateToProps = (state, ownProps) => {
	const { productInfo } = state.productData;
	let {
		customFields = {},
		vanityUrl,
		components = {},
		defaultPg,
		templateKey,
	} = state.slugInfo; //change when backend updated

	let { productGroups = EMPTY_ARRAY } = (components.productTab || EMPTY_OBJECT);
	let sliderBox = (components.sliderBox || EMPTY_OBJECT);
	let { enabled: isComingSoon } = (components.comingSoon || EMPTY_OBJECT);

	const { dir, slug, filters } = ownProps.match.params;
	let pg = filtersObj(filters).pg;
	pg = pg ? `${dir}/${slug}:productTab:${pg}` : defaultPg;

	const activePG = getActivePG(pg, productInfo.productList, productGroups);
	const { disableIntelIcon, disableMSIcon } = activePG || {};
	const { disableAutoHide, autoHideType } = Helpers.getAutoHideComponent(state.slugInfo);

	const { status, destination } = state.redirects || {};
	return {
		components,
		defaultPg,
		activePG,
		pgList: mapPglist(productGroups, state.router.location),
		pgKeys: reducePgKeys(productGroups),
		isComingSoon,
		disableIntelIcon,
		disableMSIcon,
		stateSlug: vanityUrl,
		comingSoonLinks: customFields.comingSoonLinks,
		comingSoonIntel: customFields.comingSoonIntel,
		templateKey,
		match: ownProps.match,
		router: state.router,
		testFlags: state.testFlags,
		filtersObj,
		sliderBox,
		disableAutoHide,
		autoHideType,
		status,
		destination,
		productList: productInfo.productList,
		pg
	};
};


const mapDispatchToProps = (dispatch) => {
	return {
		fetchProducts: (key) => {
			return dispatch(fetchProducts(key))
		},
		prefetchProducts: vanityUrl => dispatch(prefetchProducts(vanityUrl))
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withError(SalePageTemplate));
